'use strict';

var stringPrototype = require('./String.prototype');

module.exports = {
	prototype: stringPrototype,
	shim: function shimString() {
		stringPrototype.shim();
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/String.js
// module id = 802
// module chunks = 0